import { render, staticRenderFns } from "./ProductEditBuy.vue?vue&type=template&id=c847abc6"
import script from "./ProductEditBuy.vue?vue&type=script&lang=ts"
export * from "./ProductEditBuy.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditBuy.vue?vue&type=style&index=0&id=c847abc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports